import UserApi from 'common/api/UserApi';
import {createDraftActions, createFetchListActions} from 'common/actions/utils';
import Address from 'ondemand/types/Address';


const userApi = new UserApi();

export const {
  fetchRiderAddressesIfNeeded,
  deleteRiderAddress,
} = createFetchListActions({
  name: 'rider address',
  pluralName: 'rider addresses',
  idProp: 'addressId',
  DataType: Address,
  api: userApi,
});

export const {
  newRiderAddressDraft,
  setRiderAddressDraft,
  editRiderAddressDraft,
  clearRiderAddressDraft,
  sendRiderAddressDraft,
} = createDraftActions({
  name: 'rider address',
  DataType: Address,
  api: userApi,
});



// WEBPACK FOOTER //
// ./src/ondemand/actions/riderAddress.js